module.exports = __webpack_public_path__ + "media/site/images/scroll-white-0f5c2b5a561c2076ab705d6e9c961639.png";